import { init } from "../init-streaming";
import { HomePage } from "../pages/home/home-page";
init(HomePage);
